var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.state == 1)?_c('div',[(_vm.active == 1)?_c('div',[_c('enterprise-information',{on:{"jumpStep":_vm.jumpStep}})],1):_vm._e()]):_vm._e(),(_vm.state == 2)?_c('div',[_c('authentication',{on:{"jumpStep":_vm.jumpStep}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }